import BenefitsInTabsBlock from './BenefitsInTabsBlock'
import BenefitsInTabsCardBlock from './BenefitsInTabsCardBlock'

export { BenefitsInTabsBlock, BenefitsInTabsCardBlock }
